var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"color":"grey","outlined":""},on:{"click":function () { return _vm.action(); }}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("mdi-refresh")]),_vm._v(" Refresh ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }